// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { MOBILE_ERROR } from './constants';

export function setMobileError(data) {
  return {
    type: MOBILE_ERROR,
    data: data,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MOBILE_ERROR:
      return {
        ...state,
        mobileError: action.data,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/redux/setMobileError.js